import {AxiosInstance, AxiosResponse} from "axios";

/** What the HDS details of a consumer, as far as Connect reads them. */
export interface ConsumerDetails {
    /** The consumer key. */
    key: string;
    /** The insured identifier the consumer is covered under: the insured's own, for a beneficiary. */
    insured_identifier: {
        id: number;
        /** The NIR, served to the pharmacy the consumer belongs to. */
        nir: string | null;
    };
}

/**
 * The consumer details resource, on the HDS.
 *
 * @param client The injected client.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Read a consumer's details, its NIR included.
         *
         * @param consumerKey The consumer key, c_… or b_….
         */
        async details(consumerKey: string): Promise<ConsumerDetails> {
            return client.get(`/consumers/${consumerKey}/details`)
                .then((response: AxiosResponse) => response.data.data);
        }
    };
}
